// extracted by mini-css-extract-plugin
export default {"imageWrapper":"iK-z","twoColumnImage":"jK-z"};